{
  "title": "Vampiric Touch",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level necromancy",
  "level": 3,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "The touch of your shadow-wreathed hand can siphon force from others to heal your wounds. Make a melee spell attack against a creature within your reach. On a hit, the target takes 3d6 necrotic damage, and you regain hit points equal to half the amount of necrotic damage dealt. Until the spell ends, you can make the attack again on each of your turns as an action.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, the damage increases by 1d6 for each slot level above 3rd."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
